export default "__VITE_ASSET__51a4df88__"